import { useEffect, useState } from "react";
import { useSourceSystem } from "../../../hooks/useSourceSystem";
import { useSelector } from "react-redux";
import {
  getAppraisalData,
  getQuestionsAndAnswers
} from "../../../store/selectors";
import { useDispatch } from "react-redux";
import { appraisalSlice } from "../../../store/slices/Appraisal";
import {
  questionPresentationContent,
  yesMaskValue
} from "../../../data/QuestionPresentation";
import { sortAnswers } from "../../helpers";
function useRadioAndSelectQuestion({ question }) {
  const dispatch = useDispatch();
  const { questionValidation } = useSelector(getAppraisalData);
  const {
    sourceSystem: { getStepperPercentageValue },
    sourceSystem: { analyticSearchParam }
  } = useSourceSystem();
  const percentageStep =
    getStepperPercentageValue && getStepperPercentageValue();
  const { vehicleLoading } = useSelector((state) => state);
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const noDamageAnswer = question.answers[0];
  const noDamageAnswerID = noDamageAnswer.id;
  const answersForSelect = [...question.answers].slice(1);
  const sortedAnswersForSelect = sortAnswers(answersForSelect);
  const allAnswersSorted = sortAnswers([...question.answers])

  const {
    groupName,
    labelForSelect,
    component: {
      content: { showSelectLabel, showSelectValue }
    }
  } = questionPresentationContent[question.id];

  const [answer, setAnswer] = useState("");

  useEffect(() => {
    setAnswer(storedAnswer ? storedAnswer : "");
  }, [question.selectedAnswer, questionsAndAnswers, question.id, storedAnswer]);

  const handleAnswerChange = (answerId) => {
    const formatValue =
      parseInt(answerId) > yesMaskValue ? parseInt(answerId) : yesMaskValue;

    dispatch(appraisalSlice.actions.setAnswersChanged(true));
    if (questionValidation) {
      dispatch(appraisalSlice.actions.setQuestionValidation(""));
    }
    setAnswer(answerId);
    dispatch(
      appraisalSlice.actions.setQuestionsAndAnswers({
        [question.id]: [formatValue]
      })
    );
  };

  return {
    percentageStep,
    vehicleLoading,
    noDamage: noDamageAnswerID,
    error: questionValidation,
    handleChange: handleAnswerChange,
    sortedAnswersForSelect,
    answer,
    labelForSelect: labelForSelect || "",
    groupName: groupName || "",
    noDamageLabel: noDamageAnswer.label,
    showSelectLabel,
    showSelectValue,
    allAnswersSorted
  };
}

export default useRadioAndSelectQuestion;
